export const FETCH_SUBJECT = 'FETCH_SUBJECT';
export const FETCH_ALERT_SUBJECT = 'FETCH_ALERT_SUBJECT';
export const FETCH_SUBJECT_SUCCESS = 'FETCH_SUBJECT_SUCCESS';
export const PUSH_SUBJECT_MEMBER = 'PUSH_SUBJECT_MEMBER';
export const REMOVE_SUBJECT_MEMBER = 'REMOVE_SUBJECT_MEMBER';
export const UPDATE_SUBJECT_MEMBER_SUCCESS = 'UPDATE_SUBJECT_MEMBER_SUCCESS';
export const CREATE_SUBJECT_INDEX = 'CREATE_SUBJECT_INDEX';
export const CREATE_SUBJECT_INDEX_SUCCESS = 'CREATE_SUBJECT_INDEX_SUCCESS';

export const createSubjectIndex = (subjectId) => ({
  type: CREATE_SUBJECT_INDEX,
  subjectId,
})

export const createSubjectIndexSuccess = () => ({
  type: CREATE_SUBJECT_INDEX_SUCCESS
})

export const fetchSubject = ({id, isAppend, name, subjectId, groupId, isPrivate, isForMember, label, subjectType, limit, offset, parentSubjectId}) => ({
  type: FETCH_SUBJECT,
  id,
  subjectId,
  groupId,
  isPrivate,
  isForMember,
  label,
  name,
  subjectType,
  limit,
  offset,
  isAppend,
  parentSubjectId
});

export const fetchAlertSubject = ({id, isAppend, name, subjectId, groupId, isPrivate, isForMember, label, subjectType, limit, offset}) => ({
  type: FETCH_ALERT_SUBJECT,
  id,
  subjectId,
  groupId,
  isPrivate,
  isForMember,
  label,
  name,
  subjectType,
  limit,
  offset,
  isAppend
});


export const fetchSubjectSuccess = ({id, isAppend, subjects}) => ({
  type: FETCH_SUBJECT_SUCCESS,
  id,
  subjects,
  isAppend
});

export const pushSubjectMember = (data) => ({
  type: PUSH_SUBJECT_MEMBER,
  data,
});

export const removeSubjectMember = (data) => ({
  type: REMOVE_SUBJECT_MEMBER,
  data,
});

export const updateSubjectMemberSuccess = (data) => ({
  type: UPDATE_SUBJECT_MEMBER_SUCCESS,
  data,
})



/** WEBPACK FOOTER **
 ** ./src/app/modules/subject/actions.js
 **/